/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import React, { useEffect } from 'react';

import Icon, { IconTypes } from 'components/Icon';

/**
 * This page is intended to be loaded by 3rd party sites we load into an iframe via
 * components/IFrameCallbackModal as a method for the site to redirect here to trigger
 * close/completion of the iframe modal.
 *
 * Example:
 * We open a modal to one of our partner's forms within an iframe and give them the URL
 * to this landing page to redirect to when complete. When the iframe in IFrameCallbackModal
 * loads this page, it sends a message to it to indicate the 3rd party site has finished its work.
 */
const CallbackLandingPage = () => {

  useEffect(() => {
    window?.parent?.postMessage({ action: 'complete' }, '*');
  });

  return (
    <div style={{ height: '100%' }} className="viewstrap">
      <div style={{
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}>
        <div style={{textAlign: 'center'}}>
          <Icon type={IconTypes.CircleCheck} size={50} color="green" />
          <br/><br/>
        </div>
      </div>
    </div>
  );
};

export default CallbackLandingPage;